import {
  ref,
  computed,
  watch
} from 'vue'

import {
  defineStore
} from 'pinia'

import {
  ModalProps
} from 'ant-design-vue'

import CryptoJS from 'crypto-js';

import {
  useXmTenantAndIndustryFormStore
} from './xm-tenant-and-industry-form'

import {dbUtils} from 'xmgoing-utils'
import {StorageUtils} from 'xmgoing-utils'

import {
  useUserStore
} from '@/store/modules/user';

import {
  useSwitchTenant
} from '../../../layouts/default/header/components/hooks/useSwitchTenant';
import { tokenApi } from '../../../api';

function encrypt(word: string, pwdKey: string) {
  const key = CryptoJS.enc.Utf8.parse(pwdKey);
  const srcs = CryptoJS.enc.Utf8.parse(word);
  const encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
}

export const useXmTenantAndIndustryModalStore = defineStore('xm-tenant-and-industry-modal', () => {
  const {
    t
  } = useI18n()

  const XmAgentAndIndustryFormStore = useXmTenantAndIndustryFormStore()
  const UserStore = useUserStore();

  const { _loginSuccess: loginSuccess  } = useSwitchTenant();

  const {
    validate,
    resetFields,
    getModel,
    getSecurityKey
  } = XmAgentAndIndustryFormStore

  const visible = ref(false)

  const loading = ref(false)

  const modalProps = computed<ModalProps>(() => {
    return {
      visible: visible.value,
      title: t('切换用户'),
      confirmLoading: loading.value
    }
  })

  const onCancel: ModalProps['onCancel'] = () => {
    visible.value = false
    resetFields()
  }

  const onOk: ModalProps['onOk'] = async () => {
    await validate()

    const model = getModel()
    const userInfo = dbUtils.getCachUser()

    const params = {
      tenantCode: model.tenantCode,
      username: userInfo.account,
      password: encrypt(model.password, model.pwdKey),
      language: StorageUtils.getItem('projectI18n') || 'zh-CN',
      path: `login?locale=${StorageUtils.getItem('projectI18n') || 'zh-CN'}`,
      type: 'account',
      tenantId: '000000',
      scope: 'all',
      grant_type: 'captcha',
      client_id: 'saber',
      client_secret: 'saber_secret',
      securityKey: model.securityKey,
      pwdKey: model.pwdKey,
      captchaKey: '', //验证码key
      captchaCode: '', //验证码Code
    };

    loading.value = true

    try {
      const userId = userInfo.id;

      const res: any = await tokenApi(params)

      StorageUtils.removeSessionItem(userId + '_userCurSubMenus');
      // 清空用户对象
      StorageUtils.removeSessionItem(userId + '_userObj');
      // 清空菜单信息
      StorageUtils.removeSessionItem(userId + '_menus');
      // 清空空间信息
      StorageUtils.removeSessionItem(userId + '_userSpaceInfos');

      await UserStore.logout(false, false);

      // @ts-ignore
      onCancel()

      const { data } = res;

      nextTick(() => {
        loginSuccess(data);
      })
    } finally {
      loading.value = false
    }
  }

  watch(visible, () => {
    if (visible.value) {
      getSecurityKey()
    }
  })

  return {
    visible,
    modalProps,
    onCancel,
    onOk,
    loading
  }
})
